export default {
    slideNav( state, payload )
    {
        if ( payload.i > 0 ) {

            if ( state.current.slide < state.slides.length - 1 ) state.current.slide++
        } 
        else {

            if ( state.current.slide > 0 ) state.current.slide--
        }
    },
    slideSet( state, payload )
    {
        state.current.slide = payload.i
    },

    storyNav( state, payload )
    {
        if ( payload.i > 0 ) {
            
            state.current.story++
        } 
        else {

            if ( state.current.story > 0 ) state.current.story--
        }
    },
    storySet( state, payload )
    {
        state.current.story = payload.i
    },
}